module.exports = __webpack_public_path__ + "assets/c1d2d2d8cec95664a8b729d00b51a796.png";